module.exports = __webpack_public_path__ + "static/media/000_brand elements outlines.9054d738.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/gigable/000_brand elements outlines.png
// module id = 429
// module chunks = 0